/* Akış Tema — video-bant.js
   Yalnız görünür olan video yüklenir ve oynar; dışındayken durur. Hareket azaltma / veri tasarrufunda yalnız poster. */
(() => {
  const azHareket = window.matchMedia('(prefers-reduced-motion: reduce)');
  const veriTasarrufu = () => !!(navigator.connection && navigator.connection.saveData);

  const kur = (kok) => {
    if (!kok || kok.dataset.ok) return;
    kok.dataset.ok = '1';
    const kartlar = [kok];
    const hareketli = () => !azHareket.matches && !veriTasarrufu();

    kartlar.forEach((kart) => {
      const v = kart.querySelector('[data-vb-video]');
      const dugme = kart.querySelector('[data-vb-toggle]');
      if (!v) return;
      let durdurdu = false;
      let gorunur = false;

      const oynat = () => {
        if (!hareketli() || durdurdu || !gorunur) return;
        if (!v.src) {
          v.src = v.dataset.src;
          v.preload = 'auto';
          v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
        }
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      };
      const yenile = () => {
        if (!hareketli()) {
          v.pause();
          if (dugme) dugme.hidden = true;
          return;
        }
        if (dugme) dugme.hidden = false;
        gorunur ? oynat() : v.pause();
      };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([g]) => {
          gorunur = g.isIntersecting;
          yenile();
        }, { threshold: 0.4 }).observe(kart);
      }
      if (dugme) {
        const etiket = dugme.querySelector('[data-vb-toggle-label]');
        dugme.addEventListener('click', () => {
          durdurdu = !durdurdu;
          dugme.classList.toggle('is-paused', durdurdu);
          dugme.setAttribute('aria-pressed', durdurdu ? 'true' : 'false');
          if (etiket) etiket.textContent = durdurdu ? dugme.dataset.labelPlay : dugme.dataset.labelPause;
          durdurdu ? v.pause() : oynat();
        });
      }
      azHareket.addEventListener('change', yenile);
    });
  };

  const hepsi = () => document.querySelectorAll('[data-video-bant]').forEach(kur);
  hepsi();
  document.addEventListener('shopify:section:load', hepsi);
})();
